global.jQuery = global.$ = window.jQuery = require('jquery');
var skrollr = require('skrollr');
var jsSHA = require("jsSHA");
var ScrollMagic = require('ScrollMagic');
require('cookie');
require('velocity');
import 'core-js/features/number/is-nan'
import 'custom-event-polyfill'
import {
	Navigation,
	Autoplay,
	Pagination,
	EffectFade,
	Swiper,
	Thumbs
} from 'swiper'
Swiper.use([Pagination, Autoplay, Navigation, EffectFade, Thumbs])
import {
	gsap
} from "gsap";
import {
	ScrollTrigger
} from "gsap/ScrollTrigger";
import {
	ScrollToPlugin
} from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);


$(function () {

	// Burger Menu Viewport
	const setFillHeight = () => {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}

	window.addEventListener('resize', setFillHeight);

	setFillHeight();
	
	var swiper = new Swiper('.c-slide', {
		slidesPerView: 1,
		loop: true,
		speed: 800,
		effect: 'fade',
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: '.c-slide__next',
			prevEl: '.c-slide__prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true
		},
		fadeEffect: {
			crossFade: true
		}
	});
	var topSwiper = new Swiper('.p-top-slide', {
		slidesPerView: 1,
		loop: true,
		speed: 2000,
		effect: 'fade',
		autoplay: {
			delay: 2500,
			disableOnInteraction: false,
		},
		fadeEffect: {
			crossFade: true
		}
	});
	var mySwiper = new Swiper('.p-brand-slide', {
		direction: 'horizontal',
		slidesPerView: 2,
		loopPreventsSlide: false,
		freeMode: true,
		speed: 8000,
		autoplay: {
			delay: 0,
		},
		loop: true,
		breakpoints: {
			// 画面幅が 640px 以上の場合（window width >= 640px）
			992: {
				slidesPerView: 5
			}
		}
	});
	mySwiper.on('slideChangeTransitionEnd', function (swiper) {
		swiper.autoplay.start();
	});
	
	var locationSwiper = new Swiper('.p-location-slide', {
		direction: 'horizontal',
		slidesPerView: 2,
		loopPreventsSlide: false,
		freeMode: true,
		speed: 8000,
		autoplay: {
			delay: 0,
		},
		loop: true,
		breakpoints: {
			// 画面幅が 640px 以上の場合（window width >= 640px）
			992: {
				slidesPerView: 3
			}
		}
	});
	locationSwiper.on('slideChangeTransitionEnd', function (swiper2) {
		swiper2.autoplay.start();
	});
	
	// Page Top

	const pagetop = $('.p-footer__pagetop');
	pagetop.on('click', function () {
		gsap.to(window, {
			duration: 1,
			scrollTo: 0
		});
	});

	// Global Navigation

	const burger = $('.c-burger');
	const gnav = $('.l-navGlobal');
	const header = $('.l-header');
	let burgerFlag = false;
	burger.each(function () {
		burger.on('click', function () {
			if (!burgerFlag) {
				burger.addClass('isOpen');
				gnav.addClass('isActive');
				burgerFlag = true;
				header.addClass('isActive');
			} else {
				burger.removeClass('isOpen');
				gnav.removeClass('isActive');
				header.removeClass('isActive');

				burgerFlag = false;
			}
		});
	});

	checkHeaderClass();

	function checkHeaderClass() {
		if (burger.hasClass('isOpen')) {
			burger.removeClass('isOpen');
		}
		if (gnav.hasClass('isActive')) {
			gnav.removeClass('isActive');
		}
		if (header.hasClass('isActive')) {
			header.removeClass('isActive');
		}
		burgerFlag = false;
	}
	
	const loginNav = $('.l-header__item_login');
	let LoginFlag = false;
	
	loginNav.on('click',function(){
		if (!LoginFlag) {
			$(this).addClass('active');
			LoginFlag = true;
		} else {
			$(this).removeClass('active');
			LoginFlag = false;
		}
	});

	var controller = new ScrollMagic.Controller();
	var jsAddClasses = Array.prototype.slice.call(document.getElementsByClassName('js-active')),
		jsMoveSimples = Array.prototype.slice.call(document.getElementsByClassName('js-view')),
		jsMoveMultis = Array.prototype.slice.call(document.getElementsByClassName('js-multi'));

	jsAddClasses.map(function (jsAddClass) {
		return new ScrollMagic.Scene({
				triggerElement: jsAddClass,
				triggerHook: 0.8
			}).setClassToggle(jsAddClass, 'is-active')
			.reverse(false)
			.addIndicators()
			.addTo(controller);
	});

	$('.js-view , .js-move').velocity({
		opacity: 0,
		translateY: 30
	}, 40);
	
	$('.js-left').velocity({
		opacity: 0,
		translateX: 60,
		translateY: 0
	}, 40);
	
	$('.js-right').velocity({
		opacity: 0,
		translateX: (-60),
		translateY: 0
	}, 40);

	function multiMoves(_event, _this) {
		var $self = $(_this);
		$self.find('.js-move').each(function (index) {
			$(this).velocity({
				opacity: 1,
				translateY: 0,
				translateX: 0
			}, {
				delay: 250 * index,
				duration: 800
			});
		});
	}

	function simpleMove(_event, _this) {
		var $self = $(_this);
		$self.velocity({
			opacity: 1,
			translateX: 0,
			translateY: 0
		}, {
			duration: 800
		});
	}


	jsMoveSimples.map(function (jsMoveSimple) {
		return new ScrollMagic.Scene({
			triggerElement: jsMoveSimple,
			triggerHook: 0.8,
			reverse: false,
		}).on('enter', function (event) {
			var thisTarget = jsMoveSimple;
			simpleMove(event, thisTarget);
		}).addTo(controller);
	});

	jsMoveMultis.map(function (jsMoveMulti) {
		return new ScrollMagic.Scene({
			triggerElement: jsMoveMulti,
			triggerHook: 0.8,
			reverse: false,
		}).on('enter', function (event) {
			var thisTarget = jsMoveMulti;
			multiMoves(event, thisTarget);
		}).addTo(controller);
	});

	// iframe height
	$('.js-iframe').on('load', function () {
		try {
			$(this).height(this.contentWindow.document.documentElement.scrollHeight);
		} catch (e) {}
	}).trigger('load');
	
	
	/*---------------------------------------------
		Login Pass
		---------------------------------------------*/
	var lurl = '../member/';
	var rurl = '../reserve/';

	$('#loginBtn').on('click', function () {
		var shaObj = new jsSHA('SHA-256', 'TEXT');
		var loginPass = $('input[name=loginPass]').val();
		shaObj.update(loginPass);
		var passHash = shaObj.getHash('HEX');

		if (passHash == '3716a0d9d2ef25989db2f72a67b3eb50f490e36ea764ff6d42b72c3555526114') {

			$.cookie('login', 'true', {
				path: '/'
			});
			var loginUser = $.cookie('login');
			console.log(loginUser);
			location.href = lurl;


		} else if (passHash == 'fd9f6705985065397de15fa2701353f3db781a10a8d2086ba7300068708d4d50') {

			$.cookie('reserve', 'true', {
				path: '/'
			});
			var loginUser = $.cookie('login');
			var loginUser02 = $.cookie('reserve');
			console.log(loginUser02);
			location.href = rurl;
			
		} else {
			alert('パスワードが違います');
		}
	});

	if ($('.l-main').hasClass('limited')) {
		var loginUser = $.cookie('login');
		console.log(loginUser);
		if (loginUser != 'true') {
			location.href = '../login/';
		}
	}
	

	if ($('.l-main').hasClass('reserve')) {
		var loginUser02 = $.cookie('reserve');
		console.log(loginUser02);
		if (loginUser02 != 'true') {
			location.href = '../';
		}
	}
	/*---------------------------------------------
		route search
		---------------------------------------------*/
	$('input[name=end]').on('keydown', function (e) {
		if (e.keyCode === 13) {
			$('#submit').trigger('click');
		}
	});
	
	$('#submit').on('click', function () {
		var start = encodeURIComponent($('[name=start]').val());
		var end = encodeURIComponent($('input[name=end]').val().replace('駅', ''));
		var gmap = 'http://maps.google.com/maps?saddr=' + start + '&daddr=' + end + '%e9%a7%85&dirflg=r';
		if (end == '') {
			alert('駅名を入力して下さい');
		} else {
			window.open(gmap, '_blank');
		}
	});
	
	
	$('a[href^="#"]').click(function () {
		var speed = 500,
			href = $(this).attr("href"),
			target = $(href == "#" || href == "" ? 'html' : href),
			offset = target.offset().top,
			headerHeight = $('.l-header').innerHeight(),
			position = offset - headerHeight;

		$("html, body").animate({
			scrollTop: position
		}, speed, "swing");
		return false;
	});

	//popup window
	$.fn.openwin = function (settings) {
		settings = $.extend({
			option: {
				width: false,
				height: false,
				top: false,
				left: false,
				menubar: 'no',
				toolbar: 'no',
				location: 'no',
				status: 'no',
				resizable: 'no',
				scrollbars: 'no',
				directories: 'no',
				titlebar: 'yes',
				fullscreen: 'no'
			},
			target: '_blank',
			blur: false,
			focus: false
		}, settings);

		$(this).on('click', function () {
			var options = [];
			var target = settings.target;
			var url = $(this).attr('href');

			if ($(this).attr('rel')) {
				var rel = $(this).attr('rel').split(',');
				var relOption = {};
				$.each(settings.option, function (i, rel) {
					var a = rel[i].split('=');
					relOption[a[0]] = a[1];
				});
			}

			$.each(settings.option, function (k) {
				var v = settings.option[k];
				if (relOption) {
					if (relOption[k]) {
						v = relOption[k];
					}
				}
				if (v) {
					options.push(k + '=' + v);
				}
			});
			if (relOption) {
				if (relOption['target']) {
					target = relOption['target'];
				}
			}
			var newWin = window.open(url, target, options.join(','));
			if (settings.blur === true) {
				newWin.blur();
			}
			if (settings.focus === true) {
				newWin.focus();
			}
			return false;
		});
		return this;
	};

	$('a.js-popup').openwin({
		option: {
			width: 1000,
			height: 900,
			top: false,
			left: false,
			menubar: "no",
			toolbar: "no",
			location: "no",
			status: "no",
			resizable: "yes",
			scrollbars: "yes",
			directories: "no",
			titlebar: "yes",
			fullscreen: "no"
		}
	});
	

	var heroTxt = $('.p-hero__title').html();
	var heroSpan = "";
	$(function () {
		$.when(

			heroTxt.split('').forEach(function (e) {
				heroSpan += "<span>" + e + "</span>";
			}),

			$('.p-hero__title').html(heroSpan),
			$('.p-hero__title').css('opacity','1')

		).done(function () {
			$('.p-hero__title span').each(function (index) {
				$(this).velocity({
					opacity: 1
				}, {
					delay: 100 * index,
					duration: 250
				});
			});
		});
	});
	$('.js-open-modal').on('click',function(){
		if( $(this).hasClass("-illust") ){
			$('.-illustmodal').addClass('is-active');
		}else{
			$('.p-plan-modal').addClass('is-active');
			$('.-illustmodal').removeClass('is-active');
		}
	});
	
	$('.p-plan-modal__close').on('click',function(){
		$('.p-plan-modal').removeClass('is-active');
	});
	
	$('.p-plan-modal__cover').on('click',function(){
		$('.p-plan-modal').removeClass('is-active');
	});
	
	$('.p-plan-tab').click(function() {
		var index = $('.p-plan-tab').index(this);
		$('.p-plan-tab, .p-plan-panel__tab').removeClass('active');
		$(this).addClass('active');
		$('.p-plan-panel__tab').eq(index).addClass('active');
	});
	
	
	function TopAnime(){
		
		$('.p-top-splash__cover').velocity({
			opacity : 0
		},{
			duration : 1000,
			complete : function(){
				$('.p-top-splash__copy').velocity({
					opacity : 1
				},{
					duration : 1000,
					delay : 1500,
					complete : function(){
						$('.p-top-hero').css("opacity","1");

						$('.p-top-splash__copy').velocity({
							opacity : 0
						},{
							duration : 1800,
							delay : 1000
						});

						$('.p-top-splash').velocity({
							backgroundPositionY : ('100%')
						},{
							duration : 3400,
							delay : 2000
						}).velocity({
							opacity : 0
						},{
							duration:800,
							delay : 2500,
							display:'none',
							complete: function(){
								topSwiper.slideTo(1);
								topSwiper.autoplay.start();
								$.cookie('mvskip', 'mvskip', {
									path: '/',
									expires: 1
								});
								var mvSkips = $.cookie('mvskip');
								console.log(mvSkips);
							}
						});
					}
				});
			}
		});
		
	}
	
	function topAnimeSkip(){
		$('.p-top-splash__cover').stop().velocity("stop");
		$('.p-top-splash__copy').stop().velocity("stop");
		$('.p-top-splash').stop().velocity("stop");
		$('.p-top-hero').css("opacity","1");
		
		$('.p-top-splash').velocity({
			opacity: 0
			}, {
			duration: 1000,
			complete: function () {
				var mvSkips = $.cookie('mvskip');
				console.log(mvSkips);
				$(this).css('display', 'none');
				$.cookie('mvskip', 'mvskip', {
					path: '/',
					expires: 1
				});
				topSwiper.slideTo(1);
				topSwiper.autoplay.start();
			}
		});
	}
	
	
	$('.p-top-splash__skip').on('click',function(){
		topAnimeSkip();
	});
	
	$('.p-top-splash__replay').on('click',function(){
		$.removeCookie('mvskip');
	});
	
	if ($('.l-main').hasClass('top')) {
		var mvSkips = $.cookie('mvskip');
		console.log(mvSkips);
		if (mvSkips != 'mvskip') {
			topSwiper.autoplay.stop();
			TopAnime();
		}else{
			topAnimeSkip();
		}
	}
	
	

});


/*---------------------------------------------
	skrollr setting
---------------------------------------------*/

var isMobile = false;

isMobile = $('html').is('.skrollr-mb');

if (!isMobile) {
	window.onload = function () {
		var s = skrollr.init({
			forceHeight: false,
			mobileDeceleration: 0.01,
			mobileCheck: function () {
				return isMobile;
			}
		});
	}
}